import { routes } from "@/services/donations.service";
import useSWR from "swr";
import { fetcherV2 } from "@gogive/services";
import { Donations } from "@/types/models/Donations";
import type { DonationStatsFilters } from "@/hooks/useDonationStats";

export type DonationTimeSerieFilters = DonationStatsFilters;

function buildTimeSerieParams(
  filters: DonationTimeSerieFilters
): Record<string, string | number> {
  const params: Record<string, string | number> = {
    type: "grossAmount",
  };
  if (filters.status) params.status = filters.status;
  if (filters.donationKind) params.donationType = filters.donationKind;
  if (filters.campaignId != null) params.campaignId = filters.campaignId;
  if (filters.fundraisingCampaignId)
    params.fundraisingCampaignId = filters.fundraisingCampaignId;
  if (filters.search) params.search = filters.search;
  if (filters.startDate) params.startDate = filters.startDate;
  if (filters.endDate) params.endDate = filters.endDate;
  return params;
}

export function useDonationTimeSerie(
  filters: DonationTimeSerieFilters = {}
) {
  const params = buildTimeSerieParams(filters);

  const { data, isLoading } = useSWR(
    [routes.timeSerie, params],
    fetcherV2<Donations[]>,
    {
      revalidateIfStale: true,
      revalidateOnFocus: true,
      revalidateOnReconnect: true,
      suspense: false,
      shouldRetryOnError: false,
    }
  );

  return {
    donations: data ?? [],
    isLoading,
  };
}
